import { axiosClient } from './base'

const LIST_GOVERNORATES = '/api/governorate'

export const listGovernorates = () => axiosClient.get(LIST_GOVERNORATES)
